import { combineEpics } from 'redux-observable';

import screensEpic from './screens';
import editAddressEpic from './editAddress';
import trackingEpic from './tracking';
import transactionEpic from './transaction';
import authEpic from './auth';
import cartEpic from './cart';
import worldPayEpic from './worldpay';
import routesEpic from './routes';

const getEpics = () => {
  if (process.browser) {
    return combineEpics(
      routesEpic,
      screensEpic,
      trackingEpic,
      transactionEpic,
      authEpic,
      cartEpic,
      worldPayEpic,
      editAddressEpic
    );
  }

  /* NOTE: Omit `trackingEpic` from server-side. */
  return combineEpics(
    routesEpic,
    screensEpic,
    transactionEpic,
    authEpic,
    worldPayEpic
  );
};

const rootEpic = getEpics();

export default rootEpic;
